import PropTypes from "prop-types";
import React from "react";

// People glyph for the main-nav "CRM" item. Stroke is inherited from CSS
// (.main-menu-inline-icon) so it recolors on hover/active.
const CrmNavIcon = ({ className = "main-menu-inline-icon", size = 17 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    style={{ marginTop: "-3px", minWidth: `${size}px` }}
    aria-hidden="true"
  >
    <path
      d="M22 21V19C22 17.1362 20.7252 15.5701 19 15.126M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M17 21C17 19.1362 17 18.2044 16.6955 17.4693C16.2895 16.4892 15.5108 15.7105 14.5307 15.3045C13.7956 15 12.8638 15 11 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

CrmNavIcon.propTypes = { className: PropTypes.string, size: PropTypes.number };

export default CrmNavIcon;
